import { Pagination } from '@calendly/ui/components/pagination';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useEffect, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LoadingState from 'components/core/loading_state';
import { ORGANIZATION_INVITATION_PERMISSIONS } from 'constants/organization_invitation_permissions';
import { useQueryParams } from 'hooks/use_query_params';
import { orgInvitationPermissionsSelector } from 'selectors/current_organization';
import { isAdminOrOwnerSelector, isOnlyGroupAdminSelector } from 'selectors/current_user';
import { BatchControls } from '../batch_controls';
import { ControlsContainer } from '../controls_container';
import { PendingBatchControls } from './pending_batch_controls';
import { RemovePopup } from './remove_popup';
import { filterTermSelector, invitationsSelector, isLoadingSelector, isRemoveInvitationsPopupOpenSelector, paginationSelector, selectedEntitiesCountSelector } from './selectors';
import { clearSelection, initPage, search, updatePage, resetState } from './slice';
import { PendingUsersTable } from './table';
const paginationContainerCss = "p16mkq1x";
const PaginationContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(paginationContainerCss, props.className)} />;
});
export const PendingUsers = () => {
  const dispatch = useDispatch();
  const {
    page
  } = useQueryParams();
  const pagination = useSelector(paginationSelector);
  const invitations = useSelector(invitationsSelector);
  const isLoading = useSelector(isLoadingSelector);
  const isRemovePopupOpen = useSelector(isRemoveInvitationsPopupOpenSelector);
  const selectionCount = useSelector(selectedEntitiesCountSelector);
  const anySelectedEntities = selectionCount > 0;
  const isAdminOrOwner = useSelector(isAdminOrOwnerSelector);
  const isOnlyGroupAdmin = useSelector(isOnlyGroupAdminSelector);
  const handleSearch = query => dispatch(search(query));
  const filterTerm = useSelector(filterTermSelector);
  const orgInvitationPermissions = useSelector(orgInvitationPermissionsSelector);
  const isDesktopUp = useDeviceType('isDesktopUp');
  const canInviteAsGroupAdmin = isOnlyGroupAdmin && [ORGANIZATION_INVITATION_PERMISSIONS.GROUP_ADMIN, ORGANIZATION_INVITATION_PERMISSIONS.USER].includes(orgInvitationPermissions);
  const canInviteAsEndUser = !isAdminOrOwner && !isOnlyGroupAdmin && orgInvitationPermissions === ORGANIZATION_INVITATION_PERMISSIONS.USER;
  useEffect(() => {
    dispatch(initPage());
    return () => {
      dispatch(resetState());
    };
  }, [dispatch]);
  useEffect(() => {
    if (!isLoading && page && page > 1 && invitations.length === 0) {
      dispatch(updatePage({
        page: 1
      }));
    }
  }, [dispatch, invitations, page, isLoading]);
  return <>
      {anySelectedEntities && isDesktopUp && (isAdminOrOwner || canInviteAsGroupAdmin || canInviteAsEndUser) && <BatchControls selectionCount={selectionCount} onClose={() => dispatch(clearSelection())}>
          <PendingBatchControls />
        </BatchControls>}
      {!anySelectedEntities && <ControlsContainer filterTerm={filterTerm} handleSearch={handleSearch} isAdminOrOwner={isAdminOrOwner} />}
      {isLoading && <LoadingState />}
      {!isLoading && <div data-component="pending-users">
          <PendingUsersTable invitations={invitations} />
          <PaginationContainer>
            <Pagination {...pagination} onPageClick={nextPage => dispatch(updatePage({
          page: nextPage
        }))} />
          </PaginationContainer>
        </div>}
      {isRemovePopupOpen && <RemovePopup />}
    </>;
};

require("./pending_users.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./pending_users.js");